module.exports = {
    skilltrees: {
        0: "Bow & Crossbow",
        1: "Passive & Magic",
        2: "Javelin & Spear",
        3: "Fire",
        4: "Lightning",
        5: "Cold",
        6: "Curses",
        7: "Poison & Bone",
        8: "Summoning",
        9: "Combat",
        10: "Offensive Auras",
        11: "Defensive Auras",
        12: "Combat",
        13: "Masteries",
        14: "Warcries",
        15: "Summoning",
        16: "Shape Shifting",
        17: "Elemental",
        18: "Traps",
        19: "Shadow Disciplines",
        20: "Martial Arts"
    },
    skillTreeOffsets: {
    	0: 0,
    	1: 3,
    	2: 6,
    	3: 9,
    	4: 12,
    	5: 15,
    	6: 18
    },
    list: {
        0:   "Attack",
        1:   "Kick",
        2:   "Throw Item",
        3:   "Unsummon",
        4:   "Left Hand Throw",
        5:   "Left Hand Swing",
        6:   "Magic Arrow",
        7:   "Fire Arrow",
        8:   "Inner Sight",
        9:   "Critical Strike",
        10:  "Jab",
        11:  "Cold Arrow",
        12:  "Multiple Shot",
        13:  "Dodge",
        14:  "Power Strike",
        15:  "Poison Javelin",
        16:  "Exploding Arrow",
        17:  "Slow Missiles",
        18:  "Avoid",
        19:  "Impale",
        20:  "Lightning Bolt",
        21:  "Ice Arrow",
        22:  "Guided Arrow",
        23:  "Penetrate",
        24:  "Charged Strike",
        25:  "Plague Javelin",
        26:  "Strafe",
        27:  "Immolation Arrow",
        28:  "Dopplezon",
        29:  "Evade",
        30:  "Fend",
        31:  "Freezing Arrow",
        32:  "Valkyrie",
        33:  "Pierce",
        34:  "Lightning Strike",
        35:  "Lightning Fury",
        36:  "Fire Bolt",
        37:  "Warmth",
        38:  "Charged Bolt",
        39:  "Ice Bolt",
        40:  "Frozen Armor",
        41:  "Inferno",
        42:  "Static Field",
        43:  "Telekinesis",
        44:  "Frost Nova",
        45:  "Ice Blast",
        46:  "Blaze",
        47:  "Fire Ball",
        48:  "Nova",
        49:  "Lightning",
        50:  "Shiver Armor",
        51:  "Fire Wall",
        52:  "Enchant",
        53:  "Chain Lightning",
        54:  "Teleport",
        55:  "Glacial Spike",
        56:  "Meteor",
        57:  "Thunder Storm",
        58:  "Energy Shield",
        59:  "Blizzard",
        60:  "Chilling Armor",
        61:  "Fire Mastery",
        62:  "Hydra",
        63:  "Lightning Mastery",
        64:  "Frozen Orb",
        65:  "Cold Mastery",
        66:  "Amplify Damage",
        67:  "Teeth",
        68:  "Bone Armor",
        69:  "Skeleton Mastery",
        70:  "Raise Skeleton",
        71:  "Dim Vision",
        72:  "Weaken",
        73:  "Poison Dagger",
        74:  "Corpse Explosion",
        75:  "Clay Golem",
        76:  "Iron Maiden",
        77:  "Terror",
        78:  "Bone Wall",
        79:  "Golem Mastery",
        80:  "Raise Skeletal Mage",
        81:  "Confuse",
        82:  "Life Tap",
        83:  "Poison Explosion",
        84:  "Bone Spear",
        85:  "Blood Golem",
        86:  "Attract",
        87:  "Decrepify",
        88:  "Bone Prison",
        89:  "Summon Resist",
        90:  "Iron Golem",
        91:  "Lower Resist",
        92:  "Poison Nova",
        93:  "Bone Spirit",
        94:  "Fire Golem",
        95:  "Revive",
        96:  "Sacrifice",
        97:  "Smite",
        98:  "Might",
        99:  "Prayer",
        100: "Resist Fire",
        101: "Holy Bolt",
        102: "Holy Fire",
        103: "Thorns",
        104: "Defiance",
        105: "Resist Cold",
        106: "Zeal",
        107: "Charge",
        108: "Blessed Aim",
        109: "Cleansing",
        110: "Resist Lightning",
        111: "Vengeance",
        112: "Blessed Hammer",
        113: "Concentration",
        114: "Holy Freeze",
        115: "Vigor",
        116: "Conversion",
        117: "Holy Shield",
        118: "Holy Shock",
        119: "Sanctuary",
        120: "Meditation",
        121: "Fist Of The Heavens",
        122: "Fanaticism",
        123: "Conviction",
        124: "Redemption",
        125: "Salvation",
        126: "Bash",
        127: "Sword mastery",
        128: "Axe mastery",
        129: "Mace mastery",
        130: "Howl",
        131: "Find Potion",
        132: "Leap",
        133: "Double Swing",
        134: "Pole Arm Mastery",
        135: "Throwing Mastery",
        136: "Spear Mastery",
        137: "Taunt",
        138: "Shout",
        139: "Stun",
        140: "Double Throw",
        141: "Increased Stamina",
        142: "Find Item",
        143: "Leap Attack",
        144: "Concentrate",
        145: "Iron Skin",
        146: "Battle Cry",
        147: "Frenzy",
        148: "Increased Speed",
        149: "Battle Orders",
        150: "Grim Ward",
        151: "Whirlwind",
        152: "Berserk",
        153: "Natural Resistance",
        154: "War Cry",
        155: "Battle Command",
        156: "Fire Hit",
        157: "Unholy Bolt",
        158: "Skeleton Raise",
        159: "Maggot Egg",
        160: "Shaman Fire",
        161: "Magottup",
        162: "Magottdown",
        163: "Magottlay",
        164: "Andrial Spray",
        165: "Jump",
        166: "Swarm_move",
        167: "Nest",
        168: "Quick Strike",
        169: "Vampire Fireball",
        170: "Vampire Firewall",
        171: "Vampire Meteor",
        172: "Gargoyle Trap",
        173: "Spider Lay",
        174: "Vampire Heal",
        175: "Vampire Raise",
        176: "Submerge",
        177: "Fetish Aura",
        178: "Fetish Inferno",
        179: "Zakarum Heal",
        180: "Emerge",
        181: "Resurrect",
        182: "Bestow",
        183: "Missile Skill1",
        184: "Mon Teleport",
        185: "Prime Lightning",
        186: "Prime Bolt",
        187: "Prime Blaze",
        188: "Prime Firewall",
        189: "Prime Spike",
        190: "Prime Ice Nova",
        191: "Prime Poison Ball",
        192: "Prime Poison Nova",
        193: "Diablight",
        194: "Diabcold",
        195: "Diabfire",
        196: "Fingermagespider",
        197: "Diabwall",
        198: "Diabrun",
        199: "Diabprison",
        200: "Poison Ball Trap",
        201: "Andy Poison Bolt",
        202: "Hireable Missile",
        203: "Desert Turret",
        204: "Arcane Tower",
        205: "Monblizzard",
        206: "Mosquito",
        207: "Cursed Ball Trap Right",
        208: "Cursed Ball Trap Left",
        209: "Monfrozenarmor",
        210: "Monbonearmor",
        211: "Monbonespirit",
        212: "Moncursecast",
        213: "Hellmeteor",
        214: "Regurgitatoreat",
        215: "Monfrenzy",
        216: "Queendeath",
        217: "Scroll Of Identify",
        218: "Book Of Identify",
        219: "Scroll Of Townportal",
        220: "Book Of Townportal",
        221: "Raven",
        222: "Plague Poppy",
        223: "Wearwolf",
        224: "Shape Shifting",
        225: "Firestorm",
        226: "Oak Sage",
        227: "Summon Spirit Wolf",
        228: "Wearbear",
        229: "Molten Boulder",
        230: "Arctic Blast",
        231: "Cycle Of Life",
        232: "Feral Rage",
        233: "Maul",
        234: "Eruption",
        235: "Cyclone Armor",
        236: "Heart Of Wolverine",
        237: "Summon Fenris",
        238: "Rabies",
        239: "Fire Claws",
        240: "Twister",
        241: "Vines",
        242: "Hunger",
        243: "Shock Wave",
        244: "Volcano",
        245: "Tornado",
        246: "Spirit Of Barbs",
        247: "Summon Grizzly",
        248: "Fury",
        249: "Armageddon",
        250: "Hurricane",
        251: "Fire Trauma",
        252: "Claw Mastery",
        253: "Psychic Hammer",
        254: "Tiger Strike",
        255: "Dragon Talon",
        256: "Shock Field",
        257: "Blade Sentinel",
        258: "Quickness",
        259: "Fists Of Fire",
        260: "Dragon Claw",
        261: "Charged Bolt Sentry",
        262: "Wake Of Fire Sentry",
        263: "Weapon Block",
        264: "Cloak Of Shadows",
        265: "Cobra Strike",
        266: "Blade Fury",
        267: "Fade",
        268: "Shadow Warrior",
        269: "Claws Of Thunder",
        270: "Dragon Tail",
        271: "Lightning Sentry",
        272: "Inferno Sentry",
        273: "Mind Blast",
        274: "Blades Of Ice",
        275: "Dragon Flight",
        276: "Death Sentry",
        277: "Blade Shield",
        278: "Venom",
        279: "Shadow Master",
        280: "Royal Strike",
        281: "Wake Of Destruction Sentry",
        282: "Imp Inferno",
        283: "Imp Fireball",
        284: "Baal Taunt",
        285: "Baal Corpse Explode",
        286: "Baal Monster Spawn",
        287: "Catapult Charged Ball",
        288: "Catapult Spike Ball",
        289: "Suck Blood",
        290: "Cry Help",
        291: "Healing Vortex",
        292: "Teleport 2",
        293: "Self Resurrect",
        294: "Vine Attack",
        295: "Overseer Whip",
        296: "Barbs Aura",
        297: "Wolverine Aura",
        298: "Oak Sage Aura",
        299: "Imp Fire Missile",
        300: "Impregnate",
        301: "Siege Beast Stomp",
        302: "Minionspawner",
        303: "Catapultblizzard",
        304: "Catapultplague",
        305: "Catapultmeteor",
        306: "Boltsentry",
        307: "Corpsecycler",
        308: "Deathmaul",
        309: "Defense Curse",
        310: "Blood Mana",
        311: "Mon Inferno Sentry",
        312: "Mon Death Sentry",
        313: "Sentry Lightning",
        314: "Fenris Rage",
        315: "Baal Tentacle",
        316: "Baal Nova",
        317: "Baal Inferno",
        318: "Baal Cold Missiles",
        319: "Mega Demon Inferno",
        320: "Evil Hut Spawner",
        321: "Countess Firewall",
        322: "Impbolt",
        323: "Horror Arctic Blast",
        324: "Death Sentry Ltng",
        325: "Vinecycler",
        326: "Bearsmite",
        327: "Resurrect2",
        328: "Bloodlord Frenzy",
        329: "Baal Teleport",
        330: "Imp Teleport",
        331: "Baal Clone Teleport",
        332: "Zakarum Lightning",
        333: "Vampire Missile",
        334: "Mephisto Missile",
        335: "Doom Knight Missile",
        336: "Rogue Missile",
        337: "Hydra Missile",
        338: "Necro Mage Missile",
        339: "Monbow",
        340: "Monfirearrow",
        341: "Moncoldarrow",
        342: "Monexplodingarrow",
        343: "Monfreezingarrow",
        344: "Monpowerstrike",
        345: "Succubusbolt",
        346: "Mephfrostnova",
        347: "Monicespear",
        348: "Shaman Ice",
        349: "Diablogeddon",
        350: "Delerium Change",
        351: "Nihlathak Corpse Explosion",
        352: "Serpent Charge",
        353: "Trap Nova",
        354: "Unholy Boltex",
        355: "Shaman Fireex",
        356: "Imp Fire Missile Ex",
    },
    // NV States are a special effect on imported charms,
    // they grant visual effects only and their ids have 
    // their own list.
    nvStates: {
        0: "None",
        1: "Freeze",
        2: "Poison",
        3: "Resist Fire",
        4: "Resist Cold",
        5: "Resist Lightning",
        6: "Resist Magic",
        7: "Player Body",
        8: "Resist All",
        9: "Amplify Damage",
        10: "Frozen Armor",
        11: "Cold",
        12: "Inferno",
        13: "Blaze",
        14: "Bone Armor",
        15: "Concentrate",
        16: "Enchant",
        17: "Inner Sight",
        18: "Skill Move",
        19: "Weaken",
        20: "Chilling Armor",
        21: "Stunned",
        22: "Spider Lay",
        23: "Dim Vision",
        24: "Slowed",
        25: "Fetish Aura",
        26: "Shout",
        27: "Taunt",
        28: "Conviction",
        29: "Convicted",
        30: "Energy Shield",
        31: "Venom Claws",
        32: "Battle Orders",
        33: "Might",
        34: "Prayer",
        35: "Holy Fire",
        36: "Thorns",
        37: "Defiance",
        38: "Thunderstorm",
        39: "Lightning Bolt",
        40: "Blessed Aim",
        41: "Stamina",
        42: "Concentration",
        43: "Holy Wind",
        44: "Holy Wind Cold",
        45: "Cleansing",
        46: "Holy Shock",
        47: "Sanctuary",
        48: "Meditation",
        49: "Fanaticism",
        50: "Redemption",
        51: "Battle Command",
        52: "Prevent Heal",
        53: "Conversion",
        54: "Uninterruptable",
        55: "Iron Maiden",
        56: "Terror",
        57: "Attract",
        58: "Life Tap",
        59: "Confuse",
        60: "Decrepify",
        61: "Lower Resist",
        62: "Open Wounds",
        63: "Dopplezon",
        64: "Critical Strike",
        65: "Dodge",
        66: "Avoid",
        67: "Penetrate",
        68: "Evade",
        69: "Pierce",
        70: "Warmth",
        71: "Fire Mastery",
        72: "Lightning Mastery",
        73: "Cold Mastery",
        74: "Sword Mastery",
        75: "Axe Mastery",
        76: "Mace Mastery",
        77: "Polearm Mastery",
        78: "Throwing Mastery",
        79: "Spear Mastery",
        80: "Increased Stamina",
        81: "Iron Skin",
        82: "Increased Speed",
        83: "Natural Resistance",
        84: "Finger Mage Curse",
        85: "No Mana Regeneration",
        86: "Just Hit",
        87: "Slow Missiles",
        88: "Shiver Armor",
        89: "Battle Cry",
        90: "Blue",
        91: "Red",
        92: "Death Delay",
        93: "Valkyrie",
        94: "Frenzy",
        95: "Berserk",
        96: "Revive",
        97: "Skeleton Mastery",
        98: "Source Unit",
        99: "Redeemed",
        100: "Heath Potion",
        101: "Holy Shield",
        102: "Just Portaled",
        103: "Monfrenzy",
        104: "Corpse Nodraw",
        105: "Alignment",
        106: "Mana Potion",
        107: "Shatter",
        108: "Syn Warped",
        109: "Conversion Save",
        110: "Pregnant",
        111: "Golem Mastery",
        112: "Rabies",
        113: "Defense Curse",
        114: "Blood Mana",
        115: "Burning",
        116: "Dragon Flight",
        117: "Maul",
        118: "Corpse Noselect",
        119: "Shadow Warrior",
        120: "Feral Rage",
        121: "Skill Delay",
        122: "Progressive Damage",
        123: "Progressive Steal",
        124: "Progressive Other",
        125: "Progressive Fire",
        126: "Progressive Cold",
        127: "Progressive Lightning",
        128: "Shrine Armor",
        129: "Srhine Combat",
        130: "Shrine Resist Lightning",
        131: "Shrine Resist Fire",
        132: "Shrine Resist Cold",
        133: "Shrine Resist Poison",
        134: "Shrine Skill",
        135: "Shrine Mana Regeneration",
        136: "Shrine Stamina",
        137: "Shrine Experience",
        138: "Fenris Rage",
        139: "Wolf",
        140: "Bear",
        141: "Bloodlust",
        142: "Change Class",
        143: "Attached",
        144: "Hurricane",
        145: "Armageddon",
        146: "Invisibility",
        147: "Barbs",
        148: "Wolverine",
        149: "Oak Sage",
        150: "Vine Beast",
        151: "Cyclone Armor",
        152: "Claw Mastery",
        153: "Cloak Of Shadows",
        154: "Recycled",
        155: "Weapon Block",
        156: "Cloaked",
        157: "Quickness",
        158: "Blade Shield",
        159: "Fade",
        160: "Summon Resist",
        161: "Oaksage Control",
        162: "Wolverine Control",
        163: "Barbs Control",
        164: "Debug Control",
        165: "Itemset 1",
        166: "Itemset 2",
        167: "Itemset 3",
        168: "Itemset 4",
        169: "Itemset 5",
        170: "Itemset 6",
        171: "Runeword",
        172: "Rest In Peace",
        173: "Corpse Explosion",
        174: "Whirlwind",
        175: "Full Set Generic",
        176: "Monster Set",
        177: "Delerium",
        178: "Antidote",
        179: "Thawing",
        180: "Stamina Potion",
        181: "Passive Resist Fire",
        182: "Passive Resist Cold",
        183: "Passive Resist Lightning",
        184: "Uber Minion"
    }
}



// WEBPACK FOOTER //
// ./src/lib/skill-map.js